interface Config {
  api: string;
  okta: {
    issuer: string;
    clientId: string;
  };
}

const config: { [x: string]: Config } = {
  development: {
    api: 'http://localhost:51515/',
    okta: {
      issuer: 'https://ou.okta.com',
      clientId: '0oar5hkaszqR7RaKZ0x7'
    }
  },
  staging: {
    api: 'https://ncsyapi-summer.oudev.org/',
    okta: {
      issuer: 'https://ou.okta.com',
      clientId: '0oar5hkaszqR7RaKZ0x7'
    }
  },
  production: {
    api: 'https://apisummer.ncsy.org/',
    okta: {
      issuer: 'https://ou.okta.com',
      clientId: '0oar5hkaszqR7RaKZ0x7'
    }
  }
};

const env = process.env.NODE_ENV || 'development';
export default config[env];
